import React, { useState } from "react";
import styles from "./Database.module.scss";
import NewDatabaseModal from "./NewDatabaseModal/NewDatabaseModal";
import Input from "../../Input/Input";
import CustomButton from "../../CustomButton/CustomButton";
import LoadingContainer from "../../LoadingContainer/LoadingContainer";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { knowledgeDataBases } from "../../../api/knowledgeBases";

const Database = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [databaseData, setDataBaseData] = useState(null);
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({
    queryKey: ["knowledgeDataBases"],
    queryFn: knowledgeDataBases,
    staleTime: 5 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
  const databaseList = data?.data;

  const handleChaneDatabase = (id) => {
    const selectedDatabase = databaseList?.find((item) => item.id === id);
    setDataBaseData(selectedDatabase);
    setIsModalOpen(true);
  };

  return (
    <div className={styles.database}>
      <div className={styles.databaseHeader}>
        <p className={styles.info}>{t("database.infoText")}</p>
        <CustomButton
          blue
          plus
          width="200px"
          onClick={() => setIsModalOpen(true)}
        >
          {t("database.newDatabase")}
        </CustomButton>

        {/* <Input placeholder={t("database.searchPlaceholder")} search /> */}
        <span className="line"></span>
      </div>

      {isLoading ? (
        <LoadingContainer />
      ) : databaseList && databaseList.length > 0 ? (
        <div className={styles.databaseContent}>
          {databaseList.map((item, idx) => (
            <div key={idx} className={styles.databaseItem}>
              <h3 className={styles.itemTitle}>{item.name}</h3>
              <p className={styles.itemContent}>{item.description}</p>
              <div className={styles.itemFooter}>
                {/* <CustomButton className={styles.footerButton}>
                  {t("database.deleteButton")}
                  <DeleteIcon />
                </CustomButton> */}
                <CustomButton
                  blue
                  className={styles.footerButton}
                  onClick={() => handleChaneDatabase(item.id)}
                >
                  {t("database.editButton")}
                </CustomButton>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.databaseEmptyContent}>
          {t("database.noDatabases")}
        </div>
      )}

      {isModalOpen && (
        <NewDatabaseModal
          databaseData={databaseData}
          setDataBaseData={setDataBaseData}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </div>
  );
};

export default Database;
